import { DisplayReward } from "components/DIP/types";
import {
	Box,
	Button,
	ItemImage,
	RewardAmount,
	RewardAmountContainer,
	RewardContainer,
	RewardItem
} from "./styles";

export interface ActionBoxProps {
	rewards?: DisplayReward[];
	onClick: () => void;
}

export const ActionBox = ({ rewards, onClick }: ActionBoxProps) => (
	<Box>
		<Button variant="contained" themeColor="primary" onClick={onClick}>
			ADD
		</Button>
		{rewards?.map((displayReward) => (
			<RewardContainer key={displayReward.id}>
				<RewardItem>
					<ItemImage
						src={
							displayReward?.imageUrl || displayReward?.overrideImageUrl || ""
						}
						alt=""
					/>
					<RewardAmountContainer>
						<RewardAmount style={{ paintOrder: "stroke fill" }}>
							{displayReward.description}
						</RewardAmount>
					</RewardAmountContainer>
				</RewardItem>
			</RewardContainer>
		))}
	</Box>
);
